import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Waypoint from 'react-waypoint';
import isEmpty from 'lodash/isEmpty';

import gettext from 'js-utils/gettext';

import { GA_SETTINGS_PROP_TYPE } from '@eb/site-analytics';
import { withFollow, addFollow, FollowCard } from '@eb/follow-organizer';

import './featuredOrganizerSection.scss';

const EnhancedFollowCard = withFollow(FollowCard);

const WAYPOINT_TOP_OFFSET = '1px';

const OrganizerList = addFollow(({ organizers, children }) => {
    const organizerCards = organizers.map((organizerId) => (
        <li key={organizerId} className="list-item">
            <EnhancedFollowCard
                style="grid"
                size="standard"
                organizerId={organizerId}
                shouldHideDefaultDataPoint={true}
            />
        </li>
    ));

    return (
        <ul className="featured-organizer-section__organizer-list">
            {organizerCards}
            {children}
        </ul>
    );
});

export default class FeaturedOrganizerSection extends Component {
    state = {
        hasScrolledIntoView: false,
    };

    static propTypes = {
        /*
         * List of organizer IDs for the featured organizers
         */
        organizerIds: PropTypes.arrayOf(PropTypes.string),
        /*
         * Category for Google Analytics, used by follow organizer
         */
        gaCategory: PropTypes.string,
        /*
         * Settings for Google Analytics
         */
        gaSettings: GA_SETTINGS_PROP_TYPE,
        /*
         * Current user's ID
         */
        userId: PropTypes.string,
        /*
         * Current logged in status
         */
        isAuthenticated: PropTypes.bool,
    };

    _handleEnterViewport = () => {
        if (this.state.hasScrolledIntoView) {
            return;
        }

        this.setState({
            hasScrolledIntoView: true,
        });
    };

    render() {
        const {
            organizerIds,
            gaSettings,
            gaCategory,
            userId,
            isAuthenticated,
        } = this.props;
        const { hasScrolledIntoView } = this.state;

        if (!organizerIds || isEmpty(organizerIds)) {
            return null;
        }

        let organizerList = null;

        if (hasScrolledIntoView) {
            organizerList = (
                <OrganizerList
                    organizers={organizerIds}
                    gaSettings={gaSettings}
                    gaCategory={gaCategory}
                    userId={userId}
                    isAuthenticated={isAuthenticated}
                />
            );
        }

        return (
            <Waypoint
                onEnter={this._handleEnterViewport}
                topOffset={WAYPOINT_TOP_OFFSET}
            >
                <section className="featured-organizer-section__organizer-container">
                    <div className="featured-organizer-section__title-container">
                        <h1 className="featured-organizer-section__title eds-text-hs">
                            {gettext('Featured organizers')}
                        </h1>
                        <h2 className="featured-organizer-section__subtitle eds-text-bm">
                            {gettext(
                                'Follow the organizers from this collection and get notified when they create events.',
                            )}
                        </h2>
                    </div>
                    <div className="featured-organizer-section__organizer-list-container">
                        {organizerList}
                    </div>
                </section>
            </Waypoint>
        );
    }
}
